import { render, staticRenderFns } from "./ConfDeportistasCompania.vue?vue&type=template&id=e21d064c"
import script from "./ConfDeportistasCompania.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfDeportistasCompania.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports